export const getQueryParameter = (queryParameters:any) => {
    if(!queryParameters) {
        return ''
    }
    const queryString = Object.entries(queryParameters)
    .filter(([_, value]) => value !== undefined) // [ [ 'pageNum', 3 ], [ 'perPageNum', 10 ], [ 'category', 'food' ] ]
    .map(([key, value]) => `${key}=${value}`) // [ 'pageNum=3', 'perPageNum=10', 'category=food' ]
    .join('&'); // 'pageNum=3&perPageNum=10&category=food

    if(!queryString) {
        return ''
    }

    return `?${queryString}`;
}